module.exports = __webpack_public_path__ + "static/media/intro_order_supplier.5d89f52a.png";